export interface ReturnFormLabels {
	returnFormText: string;
	returnNumber: string;
	orderNumber: string;
	returnDate: string;
	returnAddress: string;
	sender: string;
	itemsHeader: string;
	articleName: string;
	quantity: string;
	reasonForReturn: string;
	returnDescription: string;
	returnInstructionsHeader: string;
	includeForm: string;
	instructionLeadIn: string;
	instructionIncludeForm: string;
	instructionPrintLabel: string;
	instructionEmailNotification: string;
	translateReturnReason: (reason: string) => string;
}

export function buildReturnFormLabels(instant: (key: string, interpolateParams?: object) => string): ReturnFormLabels {
	const returnInstruction = instant('returnsViewPage.return_instruction') as string;
	const instructionParts = extractReturnInstructionParts(returnInstruction);

	return {
		returnFormText: instant('returnsViewPage.return_form_text'),
		returnNumber: instant('returnsViewPage.return_number'),
		orderNumber: instant('returnsViewPage.order_num'),
		returnDate: instant('returnsViewPage.return_date'),
		returnAddress: instant('returnsViewPage.pdf_h_1'),
		sender: instant('returnsViewPage.pdf_h_2'),
		itemsHeader: instant('returnsViewPage.pdf_h2'),
		articleName: instant('returnsViewPage.pdf_th_1'),
		quantity: instant('returnsViewPage.pdf_th_2'),
		reasonForReturn: instant('returnsViewPage.pdf_th_3'),
		returnDescription: instant('returnsViewPage.pdf_th_4'),
		returnInstructionsHeader: instant('returnsViewPage.pdf_return_instructions_header'),
		includeForm: instant('returnsViewPage.include_form'),
		instructionLeadIn: instructionParts.leadIn,
		instructionIncludeForm: instructionParts.includeForm,
		instructionPrintLabel: instructionParts.printLabel,
		instructionEmailNotification: instructionParts.emailNotification,
		translateReturnReason: (reason: string) => {
			if (!reason || reason === '-') {
				return reason || '';
			}
			return instant(`returnsViewPage.${reason}`);
		}
	};
}

export function extractReturnInstructionParts(html: string) {
	const strongBlock = html.match(/<strong>([\s\S]*?)<\/strong>/i)?.[1] ?? '';
	const strongParts = strongBlock.split('<br><br>');
	const leadIn = stripHtml(html.split('<br><br><strong>')[0]);
	const includeForm = stripHtml(strongParts[0] ?? '');
	const printLabel = stripHtml(strongParts[1] ?? '');
	const emailNotification = stripHtml(html.split(/<\/strong>\s*<br><br>/i).pop() ?? '');

	return {leadIn, includeForm, printLabel, emailNotification};
}

export function stripHtml(value: string) {
	return value
		.replace(/<br\s*\/?>/gi, '\n')
		.replace(/<[^>]+>/g, '')
		.replace(/\s+/g, ' ')
		.trim();
}

export function base64ToUint8Array(base64: string) {
	const normalized = base64.includes(',') ? base64.split(',').pop()! : base64;
	const binary = atob(normalized);
	const bytes = new Uint8Array(binary.length);
	for (let i = 0; i < binary.length; i++) {
		bytes[i] = binary.charCodeAt(i);
	}
	return bytes;
}

export function bytesToBase64(bytes: Uint8Array) {
	let binary = '';
	const chunkSize = 0x8000;
	for (let i = 0; i < bytes.length; i += chunkSize) {
		const chunk = bytes.subarray(i, i + chunkSize);
		binary += String.fromCharCode(...chunk);
	}
	return btoa(binary);
}
